import * as React from 'react';
import Container from '@mui/material/Container';
import { black, fontBrand, gold, white } from '../../../../getLPTheme';
import { Typography, Box, Card, CardMedia, Paper } from "@mui/material";
import { useParams } from 'react-router-dom';  // Importar useParams para obtener el userid
import { options } from '@config';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Copyright from '../../../../auxiliares/Copyright'


let theme = createTheme({
    palette: {
      primary: {
        light: '#63ccff',
        main: black[1000], //
        dark: '#006db3',
      },
    },
    typography: {
      h5: {
        fontWeight: 500,
        fontSize: 26,
        letterSpacing: 0.5,
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiTab: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
    mixins: {
      toolbar: {
        minHeight: 48,
      },
    },
  });
  
  theme = {
    ...theme,
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: black[1000],
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
          contained: {
            boxShadow: 'none',
            '&:active': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            marginLeft: theme.spacing(1),
          },
          indicator: {
            height: 3,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            backgroundColor: theme.palette.common.white,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            margin: '0 16px',
            minWidth: 0,
            padding: 0,
            [theme.breakpoints.up('md')]: {
              padding: 0,
              minWidth: 0,
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: theme.spacing(1),
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            borderRadius: 4,
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgb(255,255,255,0.15)',
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: '#4fc3f7',
            },
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          primary: {
            fontSize: 14,
            fontWeight: theme.typography.fontWeightMedium,
          },
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            color: 'inherit',
            minWidth: 'auto',
            marginRight: theme.spacing(2),
            '& svg': {
              fontSize: 20,
            },
          },
        },
      },
      MuiAvatar: {
        styleOverrides: {
          root: {
            width: 32,
            height: 32,
          },
        },
      },
    },
  };

  const theme2 = createTheme({
    palette: {
      primary: {
        main: '#7c7c7c',
        light: '#969696',
        dark: '#565656',
        contrastText: '#242105',
      },
      secondary: {
        main: '#bababa',
        light: '#bababa',
        // dark: will be calculated from palette.secondary.main,
        contrastText: '#bababa',
      },
    },
  });

export default function CredentialValidator() {
    const avatarStyle = { height: 170, width: 170 };
    const avatarStyleQR = { height: 250, width: 250 };
    const paperStyleMedium = { height: '100%', width: "100%", alignItems: "center", justifyContent: "center" };

    const [userData, setUserData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const { userid } = useParams();

    React.useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(`${options.api.url}userid?uid=${userid}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                console.log(response)

                if (!response.ok) {
                    console.log('Error fetching user data');
                    return;
                }
                const result = await response.json();
                console.log("result: ", result);
                setUserData(result);
                setLoading(false);
            } catch (error) {
                console.log(error.message);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [userid]);

    if (loading) {
        return <Typography>Cargando credencial...</Typography>;
    }

    return (
        <>
        <ThemeProvider theme={theme}>
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <CssBaseline />
        <Box sx={{ width:"100%", flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Box component="main" sx={{ width:"100%", flex: 1, py: {xs:0, sm:1}, px: {xs:0, sm:1}, bgcolor: black[1000] }}>
                <ThemeProvider theme={theme2}>
                    <Card sx={{ width: '100%'}}>
                        <Box id="cambiar-color" sx={{backgroundColor: black[1000], position: 'relative', paddingBottom: 2}}>
                            <Container sx={{ p: 2 }}>
                                    {!userData ? (
                                        <Card sx={{ width: '100%' }}>
                                            <Box sx={{ backgroundColor: black[1000], pt: 1 }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '200%' }}>
                                                    Usuario inexistente
                                                </Typography>
                                            </Box>
                                        </Card>
                                    ) : (
                                        <Card sx={{ width: '100%' }}>
                                            <Box sx={{ backgroundColor: black[1000], pt: 1 }}>
                                            <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: "200%" }}>
                                              {userData.paymentStatus}
                                            </Typography>

                                            {!!userData.paymentStatusReason && (
                                              <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: "140%" }}>
                                                {userData.paymentStatusReason}
                                              </Typography>
                                            )}

                                            </Box>
                                            <Box sx={{ display: { xs: 'none', sm: 'flex', md: 'flex', xl: 'flex' }, flexDirection: "row", justifyContent: "center", alignItems: "center", backgroundColor: black[1000] }}>
                                                <Box sx={{ px: 3 }}>
                                                    <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                                                        <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                            <Box sx={{ borderRadius: 2, position: 'relative', bgcolor: white[50], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 346, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                <Paper elevation={24} style={paperStyleMedium}>
                                                                    <CardMedia component='img' image={"../images/plantilla-credential/card-text.png"} sx={{ width: 331, height: 563 }} />
                                                                    <Box sx={{ width: "100%", position: 'absolute', top: "28%", left: 0, backgroundColor: 'transparent' }}>
                                                                        <Box sx={{ width: 346, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                                            <CardMedia component='img' image={userData.avatar} sx={{ bgcolor: "black", p: 0 }} style={avatarStyle} />
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "65%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                                                {userData.name} {userData.lastname}
                                                                            </Typography>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                                                {userData.dni}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "82%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                                                MIEMBRO {userData.numbermembership}
                                                                            </Typography>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                                                {userData.country}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Paper>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>

                                                <Box>
                                                    <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                                                        <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                            <Box sx={{ borderRadius: 2, position: 'relative', bgcolor: white[50], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 346, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                <Paper elevation={24} style={paperStyleMedium}>
                                                                    <CardMedia component='img' image={"../images/plantilla-credential/card-text-sin-logo.png"} sx={{ width: 331, height: 563 }} />
                                                                    <Box sx={{ width: "100%", position: 'absolute', top: "15%", left: 0, backgroundColor: 'transparent' }}>
                                                                        <Box sx={{ width: 346, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                                            <CardMedia component='img' image={userData.qrCodeUrl} sx={{ bgcolor: "black", p: 0 }} style={avatarStyleQR} />
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "65.6%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                                                CUALQUIER DUDA REFERIRSE AL CORREO:
                                                                            </Typography>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                                                WORLDGOLFCLUB.ADM@GMAIL.COM
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "88%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '100%' }}>
                                                                                WWW.WORLDGOLFCLUB.COM.AR
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Paper>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: { xs: 'flex', sm: 'none', md: 'none', xl: 'none' }, flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: black[1000] }}>
                                                <Box sx={{ px: 3 }}>
                                                    <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                                                        <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                            <Box sx={{ borderRadius: 2, position: 'relative', bgcolor: white[50], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 346, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                <Paper elevation={24} style={paperStyleMedium}>
                                                                    <CardMedia component='img' image={"../images/plantilla-credential/card-text.png"} sx={{ width: 331, height: 563 }} />
                                                                    <Box sx={{ width: "100%", position: 'absolute', top: "28%", left: 0, backgroundColor: 'transparent' }}>
                                                                        <Box sx={{ width: 346, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                                            <CardMedia component='img' image={"../" + userData.avatar} sx={{ bgcolor: "black", p: 0 }} style={avatarStyle} />
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "65%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                                                {userData.name} {userData.lastname}
                                                                            </Typography>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                                                {userData.dni}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "82%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                                                MIEMBRO {userData.numbermembership}
                                                                            </Typography>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                                                {userData.country}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Paper>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>

                                                <Box>
                                                    <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                                                        <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                            <Box sx={{ borderRadius: 2, position: 'relative', bgcolor: white[50], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 346, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                <Paper elevation={24} style={paperStyleMedium}>
                                                                    <CardMedia component='img' image={"../images/plantilla-credential/card-text-sin-logo.png"} sx={{ width: 331, height: 563 }} />
                                                                    <Box sx={{ width: "100%", position: 'absolute', top: "15%", left: 0, backgroundColor: 'transparent' }}>
                                                                        <Box sx={{ width: 346, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                                            <CardMedia component='img' image={userData.qrCodeUrl} sx={{ bgcolor: "black", p: 0 }} style={avatarStyleQR} />
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "65.6%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                                                CUALQUIER DUDA REFERIRSE AL CORREO:
                                                                            </Typography>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                                                WORLDGOLFCLUB.ADM@GMAIL.COM
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ p: 2, position: 'absolute', top: "88%", left: 0 }}>
                                                                        <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                                            <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '100%' }}>
                                                                                WWW.WORLDGOLFCLUB.COM.AR
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Paper>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Card>
                                    )}
                            </Container>
                        </Box>
                    </Card>
                </ThemeProvider>
            </Box>
            <Copyright />
        </Box>
        </Box>
        </ThemeProvider>
        </>
    );
}
